import { formatDuration, statusMeta } from "./formatters";

function statusDisplay(status) {
  if (!status) return { label: "Not tracking", tone: "muted" };
  return statusMeta(status);
}

export default function PeopleActivity({ people = [], onSelectUser }) {
  if (!people.length) {
    return <p className="pa-empty">No one is signed in right now.</p>;
  }

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="pa-table">
        <thead>
          <tr>
            <th>User</th>
            <th>Active time</th>
            <th>Pause time</th>
            <th>Sessions</th>
            <th>Tracker</th>
          </tr>
        </thead>
        <tbody>
          {people.map((person) => {
            const status = statusDisplay(person.status);
            const label = person.userName || person.userId || "—";
            const canSelect = typeof onSelectUser === "function" && person.userId;
            return (
              <tr key={person.userId || label}>
                <td>
                  {canSelect ? (
                    <button
                      type="button"
                      className="pa-user-link"
                      onClick={() => onSelectUser(person)}
                    >
                      {label}
                    </button>
                  ) : (
                    label
                  )}
                </td>
                <td className="pa-active">{formatDuration(person.activeSeconds)}</td>
                <td>{formatDuration(person.pausedSeconds)}</td>
                <td>{person.sessionCount}</td>
                <td>
                  <span className={`pa-badge pa-badge--${status.tone}`}>{status.label}</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
